(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      // Page type detection ('request' is a Liquid object, not available in
      // JS — referencing it crashed this component on every non-home page).
      const path = window.location.pathname;
      if (path === '/' || /^\/[a-z]{2}(?:-[a-z]{2})?\/?$/i.test(path)) {
        this.header.classList.add('homepage');
      } else {
        this.header.classList.add('non-homepage');
      }

      // Drawer detection
      this.setupDrawerListener();
    }

    setupDrawerListener() {
      // The theme adds 'menu-open' to .section-header when the drawer opens.
      // Watch that element for instant, reliable detection on all page types.
      const sectionHeader = document.querySelector('.section-header');
      if (sectionHeader) {
        this._sectionHeaderObserver = new MutationObserver(() => {
          this.checkDrawerState();
        });
        this._sectionHeaderObserver.observe(sectionHeader, { attributes: true, attributeFilter: ['class'] });
      }

      // Also watch the details toggle directly as a fallback
      const drawerDetails = document.querySelector('#Details-menu-drawer-container');
      if (drawerDetails) {
        this._drawerObserver = new MutationObserver(() => {
          this.checkDrawerState();
        });
        this._drawerObserver.observe(drawerDetails, { attributes: true, attributeFilter: ['class', 'open'] });
      }

      // Initial check
      this.checkDrawerState();
    }

    checkDrawerState() {
      const isOpen = document.querySelector('.section-header.menu-open') ||
                     document.querySelector('#Details-menu-drawer-container.menu-opening') ||
                     document.querySelector('#Details-menu-drawer-container[open]');
      if (isOpen) {
        this.header.classList.add('drawer-active');
      } else {
        this.header.classList.remove('drawer-active');
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this._sectionHeaderObserver) this._sectionHeaderObserver.disconnect();
      if (this._drawerObserver) this._drawerObserver.disconnect();
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (!this.header.classList.contains('drawer-active')) {
        if (scrollTop > 0) {
          this.header.classList.add('scrolled');
        } else {
          this.header.classList.remove('scrolled');
        }
      }

      this.currentScrollTop = scrollTop;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
